<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <h2>{{ formTitle }}</h2>
    <a-form-model ref="dataInfo" :model="dataInfo" :rules="rules">        
      <a-divider orientation="left"><b>基本信息</b></a-divider>
      <a-form-model-item label="职级名称" prop="rankName">
        <a-input v-model="dataInfo.rankName" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="起提点" prop="originatingPoint">
        <a-input-number v-model="dataInfo.originatingPoint"  :default-value="100"  :min="0"  :max="100" @change="pointChange"
          :formatter="value => `${value}%`"  :parser="value => value.replace('%', '')" />
      </a-form-model-item>

      
      <a-divider orientation="left"><b>升级标准</b></a-divider>
      <div style="display:flex;">
      <a-form-model-item label="司龄" prop="workAge">
        <a-input v-model="dataInfo.workAge" size="default" placeholder="请输入" />
      </a-form-model-item>

      <a-form-model-item label="单位" prop="workAgeUnit"><!-- 司龄 -->
        <a-select v-model="dataInfo.workAgeUnit" size="default" placeholder="请选择">
          <a-select-option value="年">年</a-select-option>
          <a-select-option value="月">月</a-select-option>
          <a-select-option value="日">日</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="入司累计业绩" prop="workPerformance" style="margin-left:10px;">
        <a-input-number v-model="dataInfo.workPerformance" size="default"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}元`"  :parser="value => value.replace('元', '')" />
      </a-form-model-item>
      </div>
     
      <a-divider orientation="left"><b>降级标准</b></a-divider>
      <a-form-model-item label="季度平均业绩" prop="quarterlyAveragePerformance">
        <a-input-number size="default" v-model="dataInfo.quarterlyAveragePerformance"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}元`"  :parser="value => value.replace('元', '')" />
      </a-form-model-item>

      <a-divider orientation="left"><b>绩效指标</b></a-divider>
      <div style="display:flex;flex-wrap:wrap;">
      <a-form-model-item class="item_kpi" label="房源新增" prop="houseAdd">
        <a-input-number size="default" v-model="dataInfo.houseAdd"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}个/月`"  :parser="value => value.replace('个/月', '')" />
      </a-form-model-item>
      <a-form-model-item class="item_kpi" label="客源新增" prop="lesseeAdd">
        <a-input-number size="default" v-model="dataInfo.lesseeAdd" :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}个/月`"  :parser="value => value.replace('个/月', '')" />
      </a-form-model-item>
      <a-form-model-item class="item_kpi" label="带看" prop="takeLook">
        <a-input-number size="default" v-model="dataInfo.takeLook"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}次/月`"  :parser="value => value.replace('次/月', '')" />
      </a-form-model-item>
      <a-form-model-item class="item_kpi" label="一带多看" prop="inMore">
        <a-input-number size="default" v-model="dataInfo.inMore"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}次/月`"  :parser="value => value.replace('次/月', '')" />
      </a-form-model-item>
      <a-form-model-item class="item_kpi" label="一客多看" prop="lesseeSeeMore">
        <a-input-number size="default" v-model="dataInfo.lesseeSeeMore"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}次/月`"  :parser="value => value.replace('次/月', '')" />
      </a-form-model-item>
      <a-form-model-item  class="item_kpi" label="业绩" prop="performanceAmount">
        <a-input-number size="default" v-model="dataInfo.performanceAmount"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}元/月`"  :parser="value => value.replace('元/月', '')" />
      </a-form-model-item>
      <a-form-model-item class="item_kpi" label="面访" prop="interview">
        <a-input-number size="default" v-model="dataInfo.interview"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}个/月`"  :parser="value => value.replace('个/月', '')" />
      </a-form-model-item>
      <a-form-model-item class="item_kpi" label="委托" prop="entrustNum">
        <a-input-number size="default" v-model="dataInfo.entrustNum"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}份/月`"  :parser="value => value.replace('份/月', '')" />
      </a-form-model-item>
      <a-form-model-item class="item_kpi" label="钥匙" prop="keysNum">
        <a-input-number size="default" v-model="dataInfo.keysNum"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}间/月`"  :parser="value => value.replace('间/月', '')" />
      </a-form-model-item>
      <a-form-model-item class="item_kpi" label="客源跟进" prop="guestFollowUp">
        <a-input-number size="default" v-model="dataInfo.guestFollowUp"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}次/月`"  :parser="value => value.replace('次/月', '')" />
      </a-form-model-item>
      <a-form-model-item class="item_kpi" label="房源跟进" prop="houseFollowUp">
        <a-input-number size="default" v-model="dataInfo.houseFollowUp"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}次/月`"  :parser="value => value.replace('次/月', '')" />
      </a-form-model-item>
      <a-form-model-item class="item_kpi" label="五房被带看量" prop="byTakeLookHouseNum">
        <a-input-number size="default" v-model="dataInfo.byTakeLookHouseNum"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}次/月`"  :parser="value => value.replace('次/月', '')" />
      </a-form-model-item>
      <a-form-model-item class="item_kpi" label="五客带看量" prop="takeLookLesseeNum">
        <a-input-number size="default" v-model="dataInfo.takeLookLesseeNum"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}次/月`"  :parser="value => value.replace('次/月', '')" />
      </a-form-model-item>
      </div>

      
      <a-divider orientation="left"><b>业绩分配</b></a-divider>
      <div style="display:flex;">
      <a-form-model-item class="item_" label="业绩范围" prop="performanceAmount">
        <a-input-number size="default" v-model="dataInfo.boList[0].performanceStartAmount"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}元`"  :parser="value => value.replace('元', '')" />
        <!-- </a-form-model-item> -->
        ——        
        <!-- <a-form-model-item label="" prop="performanceEndAmount"> -->
        <a-input-number size="default" v-model="dataInfo.boList[0].performanceEndAmount"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}元`"  :parser="value => value.replace('元', '')" />
      </a-form-model-item>

      <a-form-model-item label="提成比例" prop="contractRatio" style="margin-left:10px;">
        <a-input-number size="default" v-model="dataInfo.boList[0].contractRatio"  :default-value="0"  :min="0"  @change="pointChange"
          :formatter="value => `${value}%`"  :parser="value => value.replace('%', '')" />
      </a-form-model-item>
      </div>
      <button>+</button>
 
      <!-- <a-form-model-item label="显示顺序" prop="postSort">
        <a-input-number v-model="dataInfo.postSort" :min="0" style="width: 100%"/>
      </a-form-model-item>
     
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="dataInfo.remark" placeholder="请输入" type="textarea" allow-clear />
      </a-form-model-item> -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { getProfession, addProfession, updateProfession } from '@/api/system/profession'

export default {
  name: 'CreateForm',
  props: {
   
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      dataInfo: {
        boList: [//职级管理 业绩分配设置业务对象list
          {
          contractRatio:undefined,	//提成比例
          id:undefined,	//新增时不传，修改时必传
          performanceEndAmount:0,	//业绩范围最大金额
          performanceStartAmount:0,	//业绩范围最小金额
        }],//业绩分配list
        byTakeLookHouseNum: 0,//五房被带看量（次/月）
        entrustNum: 0,//	委托（份/月）
        guestFollowUp: 0,//	客源跟进（次/月）
        houseAdd: 0,//	房源新增（个/月）
        houseFollowUp: 0,//	房源跟进（次/月）
        id: undefined,//新增时不传，修改时必传
        inMore: 0,//	一带多看（次/月）
        interview: 0,//	面访（个/月）
        keysNum	: 0,//钥匙（间/月）
        lesseeAdd: 0,//	客源新增（个/月）	
        lesseeSeeMore: 0,//	一客多看（次/月）
        originatingPoint: 0,//	起提点（百分比）
        performanceAmount: 0,//	业绩（元/月）
        quarterlyAveragePerformance: 0,//	季度平均业绩（元）
        rankName: undefined,//	职级名称
        takeLook: 0,//	带看（次/月）
        takeLookLesseeNum: 0,//	五客带看量（次/月）	
        workAge: 0,//	司龄
        workAgeUnit: undefined,//	司龄单位
        workPerformance: 0,//	入司累计业绩（元）
      },
      open: false,
      rules: {
        postName: [{ required: true, message: '职级编码不能为空', trigger: 'blur' }],
        postCode: [{ required: true, message: '职级名称不能为空', trigger: 'blur' }],
        postSort: [{ required: true, message: '显示顺序不能为空', trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.dataInfo = {
        boList: [//职级管理 业绩分配设置业务对象list
          {
          contractRatio:undefined,	//提成比例
          id:undefined,	//新增时不传，修改时必传
          performanceEndAmount:0,	//业绩范围最大金额
          performanceStartAmount:0,	//业绩范围最小金额
        }],//业绩分配list
        byTakeLookHouseNum: 0,//五房被带看量（次/月）
        entrustNum: 0,//	委托（份/月）
        guestFollowUp: 0,//	客源跟进（次/月）
        houseAdd: 0,//	房源新增（个/月）
        houseFollowUp: 0,//	房源跟进（次/月）
        id: undefined,//新增时不传，修改时必传
        inMore: 0,//	一带多看（次/月）
        interview: 0,//	面访（个/月）
        keysNum	: 0,//钥匙（间/月）
        lesseeAdd: 0,//	客源新增（个/月）	
        lesseeSeeMore: 0,//	一客多看（次/月）
        originatingPoint: 0,//	起提点（百分比）
        performanceAmount: 0,//	业绩（元/月）
        quarterlyAveragePerformance: 0,//	季度平均业绩（元）
        rankName: undefined,//	职级名称
        takeLook: 0,//	带看（次/月）
        takeLookLesseeNum: 0,//	五客带看量（次/月）	
        workAge: 0,//	司龄
        workAgeUnit: undefined,//	司龄单位
        workPerformance: 0,//	入司累计业绩（元）
      }
    },
     /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.open = true
      this.formTitle = '添加职级'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      const postId = row ? row.postId : ids
      getProfession(postId).then(response => {
        this.dataInfo = response.data
        this.open = true
        this.formTitle = '修改职级'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.dataInfo.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.dataInfo.postId !== undefined) {
            updateProfession(this.dataInfo).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addProfession(this.dataInfo).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    pointChange(value) {
      console.log('changed', value);
    },
  }
}
</script>
<style scoped>
.item_kpi{
  margin-right:10px;
}
</style>
